import { FC } from 'react'

import RuleRow from './RuleRow'

import type { AboutServerSectionProps } from '../../types'

type ServerRulesProps = Pick<AboutServerSectionProps, 'serverRules'>

const ServerRules: FC<ServerRulesProps> = ({ serverRules }) => {
  const sortedRules = (serverRules || []).toSorted(
    (a, b) => a.ordering - b.ordering,
  )
  return (
    <div className="flex flex-col gap-s">
      {sortedRules.map((rule, index) => (
        <RuleRow key={rule.id} ruleNumber={index + 1} rule={rule} />
      ))}
    </div>
  )
}

export default ServerRules
